import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import contactBanner from "../assets/images/contact/contact-header-bg.webp";
import contactIcons from "../assets/images/contact/contact-cubes.webp";
import "../assets/css/contact_style.css";
import "../assets/css/Responsive/contact_responsive.css";
import Swal from "sweetalert2";
import { FiPhoneCall } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import contactIcon from "../assets/images/contact/get_in_touch.webp";

export default function Contact() {
  document.title = "Milan Brass – Contact Us";
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false, // allow animations to trigger on both scroll down and up
    });
    AOS.refresh();
  }, []);
  const [submitting, setSubmitting] = useState(false);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setSubmitting(true);

  //   const form = e.currentTarget;
  //   const formData = new FormData(form);

  //   try {
  //     const res = await fetch("https://api.web3forms.com/submit", {
  //       method: "POST",
  //       body: formData,
  //     }).then((r) => r.json());

  //     if (res.success) {
  //       Swal.fire({
  //         title: "🎉 Message Sent!",
  //         text: "We’ve received your inquiry and will respond shortly.",
  //         icon: "success",
  //         background: "#1a1a2e", // custom dark background
  //         color: "#fff", // text color
  //         iconColor: "#4CAF50", // icon color
  //         confirmButtonText: "Great!",
  //         confirmButtonColor: "#4CAF50",
  //         showClass: {
  //           popup: "animate__animated animate__fadeInDown",
  //         },
  //         hideClass: {
  //           popup: "animate__animated animate__fadeOutUp",
  //         },
  //         customClass: {
  //           title: "custom-swal-title",
  //           confirmButton: "custom-swal-btn",
  //         },
  //       });
  //       form.reset();
  //     } else {
  //       Swal.fire({
  //         title: "❌ Oops!",
  //         text: res.message || "Something went wrong. Please try again.",
  //         icon: "error",
  //         background: "#1a1a2e",
  //         color: "#fff",
  //         confirmButtonText: "Retry",
  //         confirmButtonColor: "#E53935",
  //       });
  //     }
  //   } catch (err) {
  //     Swal.fire({
  //       title: "⚠ Network Error",
  //       text: "Please check your connection and try again.",
  //       icon: "warning",
  //       confirmButtonText: "OK",
  //     });
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const form = e.currentTarget;
    const formData = new FormData(form);

    // Convert form data into JSON
    const object = Object.fromEntries(formData);

    // Web3Forms configuration
    // object.access_key = "e9de3709-ff14-48fb-aec9-ec53cfbd5be9";
    object.access_key = "cc232d94-4d8b-4eb9-8f7a-9fc1d5d09b0b";
    object.subject = "New Inquiry from Milan Brass Website";
    object.from_name = "Milan Brass Website";

    try {
      const response = await fetch(
        "https://api.web3forms.com/submit",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },

          body: JSON.stringify(object),
        }
      );

      const result = await response.json();

      console.log("Web3Forms Response:", result);

      if (result.success) {
        Swal.fire({
          title: "🎉 Message Sent!",
          text: "We’ve received your inquiry and will respond shortly.",
          icon: "success",
          background: "#1a1a2e",
          color: "#fff",
          iconColor: "#4CAF50",
          confirmButtonText: "Great!",
          confirmButtonColor: "#4CAF50",
        });

        form.reset();
      } else {
        console.error("Web3Forms Error:", result);

        Swal.fire({
          title: "❌ Submission Failed",
          text:
            result.message ||
            "Something went wrong. Please try again.",
          icon: "error",
          background: "#1a1a2e",
          color: "#fff",
          confirmButtonText: "Retry",
          confirmButtonColor: "#E53935",
        });
      }
    } catch (error) {
      console.error("Contact Form Error:", error);

      Swal.fire({
        title: "⚠ Network Error",
        text: "Unable to send your message. Please try again.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <section className="contact-section">
        {/* Header Section */}
        <div
          className="contact-header-section"
          style={{ backgroundImage: `url(${contactBanner})` }}
        >
          <div className="contact-header-content">
            <div
              className="contact-header-text"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <h1>Contact Us</h1>
              <hr />
              <p>Let’s Connect — We’re Here to Help.</p>
            </div>
            <div
              className="contact-header-icons"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <img src={contactIcons} alt="Contact Icons" />
            </div>
          </div>
        </div>

        {/* Contact Info & Form */}
        <div className="contact-container">
          <div className="contact-info-box">
            <img
              src={contactIcon}
              alt="Get in Touch"
              className="contact-image"
              data-aos="fade-right"
              data-aos-delay="200"
            />
            <div
              className="contact-info-text"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <h3>Get in Touch</h3>
              <p>
                We would love to hear from you! Whether you have inquiries about
                our products, need assistance with an order, or want to discuss
                a custom requirement, our team is here to help.
              </p>
              <address>
                <strong>Address:</strong>
                <br />
                Plot no.401, GIDC - phase 2,
                <br />
                Dared, Jamnagar-361004
              </address>
              <a
                href="tel:+919714731830"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <h3>Office Number:</h3>
                <p>
                  <FiPhoneCall style={{ marginRight: "8px" }} />
                  +91 9714731830
                </p>
              </a>
              <a
                href="tel:+917096606402"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <h3>Milan Sudani Mob.No:</h3>
                <p>
                  <FiPhoneCall style={{ marginRight: "8px" }} />
                  +91 7096606402
                </p>
              </a>
              {/* <p>
                <MdOutlineEmail style={{ marginRight: "8px" }} />
                info@milanbrass.com
              </p> */}
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=info@milanbrass.milanbrass.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Send email to Milan Brass"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <p>
                  <MdOutlineEmail style={{ marginRight: "8px" }} />
                  info@milanbrass.com
                </p>
              </a>
            </div>
          </div>

          {/* Inquiry Form */}
          <div
            className="inquiry-form-box"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <h4>Inquiry Form</h4>

            <form className="inquiry-form" onSubmit={handleSubmit}>
              {/* Required by Web3Forms */}
              <input
                type="hidden"
                name="access_key"
                value="cc232d94-4d8b-4eb9-8f7a-9fc1d5d09b0b"
              />
              <input
                type="hidden"
                name="subject"
                value="New Inquiry from Website"
              />
              <input type="hidden" name="replyto" value="@" />
              <input
                type="checkbox"
                name="botcheck"
                style={{ display: "none" }}
              />

              <div className="form-group">
                <label>Email:</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone No.:</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter phone number"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Name:</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Leave Your Message:</label>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Write your message..."
                  required
                ></textarea>
              </div>

              <button type="submit" disabled={submitting}>
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <div className="contact-map">
        <iframe
          title="Location Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3701.176748447468!2d70.03508927523048!3d22.484265236222075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395718a5dc3f94db%3A0x5a2b3f983215cd6d!2sGIDC%20Phase%202%2C%20Jamnagar%2C%20Gujarat%20361004!5e0!3m2!1sen!2sin!4v1668849131425!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}


